export function isNullEmptyOrUndefined(
  value: string | null | undefined
): boolean {
  return value === null || value === undefined || value === "";
}
